import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const plantApi = createApi({
  reducerPath: "plantApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Plant"],
  endpoints: (builder) => ({
    getPlants: builder.query({
      query: (params = {}) => buildPagedListUrl("plant/", params),
      providesTags: ["Plant"],
    }),
    addPlant: builder.mutation({
      query: (newPlant) => ({
        url: "plant/",
        method: "POST",
        body: newPlant,
      }),
      invalidatesTags: ["Plant"],
    }),
    updatePlant: builder.mutation({
      query: ({ uid, ...updatedPlant }) => ({
        url: `plant/${uid}`,
        method: "PUT",
        body: updatedPlant,
      }),
      invalidatesTags: ["Plant"],
    }),
    deletePlant: builder.mutation({
      query: (uid) => ({
        url: `plant/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Plant"],
    }),
  }),
});

export const {
  useGetPlantsQuery,
  useLazyGetPlantsQuery,
  useAddPlantMutation,
  useUpdatePlantMutation,
  useDeletePlantMutation,
} = plantApi;
